import React from "react";
import CollapsibleCard from "../../../../ForBrands/ui/CollapsibleCard";
import InsightList from "../../../../ForBrands/ui/InsightList";
import { LegendRow } from "../../../../ForBrands/ui/LegendItem";
import { CHART } from "../../../../ForBrands/ui/charts/chartTokens";
import { MAKEUP_FIGURES, MAKEUP_KIND_LABELS, NO_GAPS, descriptiveNote, makeupCaption, makeupTiles } from "../teamPerformanceModel";
import { PerfTile, TileGrid } from "./perfPieces";

// What the Roster Is Missing (BUILD_SPEC B7, Jayson's T8): the makeup
// reads as cards in payload order (already sorted: high, then medium, then
// info, links to performance first), each with its severity edge, its
// kind overline and the "Linked to performance" tint; "No gaps against
// peers" when there are none. Then the four makeup metrics as tiles with a
// passive "Nth pct" chip (descriptive, B5) and a legend line saying what it
// means. One column on phones.

const RosterGapsCard = ({ makeup, peerLabel, collapse }) => {
  const tiles = makeupTiles(makeup);
  const described = descriptiveNote(tiles, MAKEUP_FIGURES);
  return (
    <CollapsibleCard title="What the Roster Is Missing" titleAs="h3" subtitle={makeupCaption(makeup, peerLabel)} {...collapse}>
      <InsightList insights={makeup?.insights} variant="cards" kindLabels={MAKEUP_KIND_LABELS} emptyText={NO_GAPS} label="Roster gaps" />
      {tiles.length > 0 && (
        <TileGrid columns={4} label="Roster metrics">
          {tiles.map((tile) => (
            <PerfTile key={tile.key} tile={tile} />
          ))}
        </TileGrid>
      )}
      <LegendRow items={[described && { key: "descriptive", swatch: "dot", color: CHART.muted, label: described }]} label="Roster metrics legend" />
    </CollapsibleCard>
  );
};

export default RosterGapsCard;
